import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($filter, $scope, $q, ModalService, ServiceRequestService) => {
    const ctrl = Object.create(BaseCtrl);
    ctrl.init = () => {
        $scope.globalMessages = [];
        $scope.resultsTruncated = false;
        $scope.maxAllowedMessages = 50; // Default in CC, but can be changed by configuration
    };

    $scope.messagesPromise = ServiceRequestService.getMessagesForSpecialist().then(
        (globalMessages) => {
            $scope.globalMessages = globalMessages.messages;
            $scope.resultsTruncated = globalMessages.truncated;
            $scope.maxAllowedMessages = globalMessages.maxAllowedMessages;
        },
        (error) => {
            console.error('Error', error);
        }
    );

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$q', 'ModalService', 'servicerequest.ServiceRequestService'];

export default fn;
